// ── Dirty-Flag ────────────────────────────────────────────────────────────
let formDirty = false;

const form = document.querySelector('#holzpreis_form');

// Alle Formular-Inputs auf einmal überwachen
if (form) {
    form.addEventListener('input', function () {
        formDirty = true;
    });
}

// Warnung beim Verlassen der Seite
window.addEventListener('beforeunload', function (e) {
    if (formDirty) {
        e.preventDefault();
        e.returnValue = '';
    }
});

// ── Speichern- und bewerbungSubmit-Button: kein dirty-Warning ──────────────────────────────────
const saveBtn = document.querySelector('input[name="saveForm"]');
if (saveBtn) {
    saveBtn.addEventListener('click', function () {
        formDirty = false;
    });
}
const bewerbungSubmitBtn = document.querySelector('input[name="bewerbungSubmit"]');
if (bewerbungSubmitBtn) {
    bewerbungSubmitBtn.addEventListener('click', function () {
        formDirty = false;
    });
}






document.addEventListener('DOMContentLoaded', function () {

    // ── Hilfsfunktion: Label-Klasse setzen/entfernen ──────────────────────────
    function syncLabel(target) {
        const formField = target.closest('.cd-formfield');
        const label = formField ? formField.querySelector('label[for="' + target.id + '"]') : null;
        if (!label) return;
        if (target.value.trim() !== '') {
            label.classList.add('float');
        } else {
            label.classList.remove('float');
        }
    }

    // ── Alle Einwilligungsfelder mit data-sync-source sammeln ─────────────────
    const syncTargets = document.querySelectorAll('[data-sync-source]');

    syncTargets.forEach(function (target) {
        const sourceId = target.getAttribute('data-sync-source');
        const source = document.getElementById(sourceId);

        if (!source) return;

        // ── Initialisierung beim Laden ────────────────────────────────────────
        // isset = "1" → TV-Record existiert (auch wenn leer) → dirty = true
        // isset = "0" → noch nie gespeichert → Quellwert kopieren wenn vorhanden
        const isset = target.getAttribute('data-sync-isset') === '1';  // ← NEU
        let dirty = isset;                                              // ← NEU (ersetzt: let dirty = target.value.trim() !== '')

        if (!dirty && source.value.trim() !== '') {
            target.value = source.value;
            syncLabel(target);
        }

        // Beim Laden: Label-Zustand für bereits befüllte Felder korrigieren
        syncLabel(target);

        // ── Einwilligungsfeld selbst bearbeitet → dirty setzen ────────────────
        target.addEventListener('input', function () {
            dirty = true;
            syncLabel(target);
        });

        // ── Quellfeld geändert → nur übertragen wenn nicht dirty ─────────────
        source.addEventListener('input', function () {
            if (!dirty) {
                target.value = source.value;
                syncLabel(target);
            }
        });
    });

});




